import { render, staticRenderFns } from "./OutstandingDaysBranch.vue?vue&type=template&id=30060944"
import script from "./OutstandingDaysBranch.vue?vue&type=script&lang=js"
export * from "./OutstandingDaysBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports